import React, { useRef } from 'react'
import useOnScreen from '../../hooks/UseOnScreen'

const TextImageWrapper = ({
  imgUrl,
  textStep,
  textHeading,
  textSubHeading,
  direction = 'row',
  subDesc,
  imgsrc,
  videoUrl = null,
}) => {
  const imageRef = useRef()
  const isVisible = useOnScreen(imageRef)

  return (
    <div className={`text-image-wrapper rounded-3xl ${direction}`}>
      <div className="left-side">
        <h6 className="step text-[#475467]">{textStep}</h6>
        <h4 className="super heading">{textHeading}</h4>
        <div className="sub-heading">{textSubHeading}</div>
        <ul className="sub-desc">{subDesc}</ul>
        {imgsrc && <img src={imgsrc} alt="home-img" />}
      </div>
      <div className="right-side" ref={imageRef}>
        {!videoUrl ? (
          <img src={imgUrl} alt="feature" className={`feature-image ${isVisible ? 'animation' : ''}`} />
        ) : (
          <video
            className={`feature-image ${isVisible ? 'animation' : ''}`}
            style={{ maxWidth: '100%', height: '100%' }}
            muted
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  )
}

export default TextImageWrapper
